import { emsClient } from '../api/clients';
import { activateChat, locateCaller } from './incidentCommands';
import { activateLiveVideo } from './liveVideoApi';

type CreateRequestedIncidentBody = {
  requestedIncidentId: string;
  callerPhoneNumber?: string;
};

function ensureSuccess(response: Response, action: string): void {
  if (!response.ok) {
    throw new Error(`${action} failed (HTTP ${response.status})`);
  }
}

export async function createIncident(requestedIncidentId: string, phoneNumbers: string[]): Promise<void> {
  const body = createRequestedIncidentBody(requestedIncidentId, phoneNumbers);
  const { response } = await emsClient().POST('/portal/v1/incident', { body });
  ensureSuccess(response, 'Create incident');
}

export async function locateCallerForRequestedIncident(
  requestedIncidentId: string,
  phoneNumbers: string[],
): Promise<void> {
  await createIncident(requestedIncidentId, phoneNumbers);
  await locateCaller(requestedIncidentId);
}

export async function startChatWithCaller(requestedIncidentId: string, phoneNumbers: string[]): Promise<void> {
  await createIncident(requestedIncidentId, phoneNumbers);
  await activateChat(requestedIncidentId);
}

export async function startVideoChatWithCaller(requestedIncidentId: string, phoneNumbers: string[]): Promise<void> {
  await createIncident(requestedIncidentId, phoneNumbers);
  const response = await activateLiveVideo(requestedIncidentId);
  ensureSuccess(response, 'Start video chat with caller');
}

function createRequestedIncidentBody(
  requestedIncidentId: string,
  phoneNumbers: string[],
): CreateRequestedIncidentBody {
  const distinctPhoneNumbers = [...new Set(phoneNumbers)];
  if (distinctPhoneNumbers.length > 1) {
    throw new Error('An Incident can be created for at most one distinct caller phone number.');
  }

  const phoneNumber = distinctPhoneNumbers[0];
  return {
    requestedIncidentId,
    ...(phoneNumber === undefined ? {} : { callerPhoneNumber: phoneNumber }),
  };
}
